import DOMPurify from "dompurify";
export function sanitizeHealthWalletHtml(html) {
    return DOMPurify.sanitize(html, { WHOLE_DOCUMENT: true });
}
export async function openSanitizedHtmlInTab(tab, blob, documentTitle) {
    const sanitized = sanitizeHealthWalletHtml(await blob.text());
    renderSandboxedHtmlInTab(tab, sanitized, documentTitle);
}
function renderSandboxedHtmlInTab(tab, sanitizedHtml, documentTitle) {
    const doc = tab.document;
    if (documentTitle) {
        doc.title = documentTitle;
    }
    doc.body.style.margin = "0";
    const iframe = doc.createElement("iframe");
    iframe.setAttribute("sandbox", "");
    iframe.srcdoc = sanitizedHtml;
    iframe.style.cssText = "display:block;width:100%;height:100vh;border:0";
    doc.body.replaceChildren(iframe);
}
